import type { FileType } from '@/types/dtos/media/media.asset.dto';
import {
  PictureAsPdfOutlined,
  ImageOutlined,
  AudioFileOutlined,
  VideoFileOutlined,
  ViewCarouselOutlined,
} from '@mui/icons-material';
import SvgIcon from '@mui/material/SvgIcon';
import type { SvgIconProps } from '@mui/material';
import { PiFilePptDuotone } from 'react-icons/pi';

interface FileTypeIconProps extends SvgIconProps {
  fileType: FileType;
}

export const FileTypeIcon = ({ fileType, ...iconProps }: FileTypeIconProps) => {
  const defaultSx = { fontSize: 24 };
  const combinedSx = iconProps.sx ? { ...defaultSx, ...iconProps.sx } : defaultSx;

  switch (fileType) {
    case 'video':
      return <VideoFileOutlined {...iconProps} sx={combinedSx} />;
    case 'audio':
      return <AudioFileOutlined {...iconProps} sx={combinedSx} />;
    case 'image':
      return <ImageOutlined {...iconProps} sx={combinedSx} />;
    case 'pdf':
      return <PictureAsPdfOutlined {...iconProps} sx={combinedSx} />;
    case 'presentation':
      return <SvgIcon component={PiFilePptDuotone} inheritViewBox {...iconProps} sx={combinedSx} />;
    case 'imageSequence':
      return <ViewCarouselOutlined {...iconProps} sx={combinedSx} />;
    default:
      return null;
  }
};
